class StudyTwoProcedureConfig {
    constructor() {
        this.STUDY_TWO_PROCEDURE_INDEX_TO_URL_MAPPING = {
            0: '/discussion',
            1: '/exploration_summary'
        };

        this.TRACKING_COOKIE_NAME = 'current_study_two_session';
    }

    getProcedureMappingConfig () {
        return  this.STUDY_TWO_PROCEDURE_INDEX_TO_URL_MAPPING;
    }

    get_tracking_cookie_name (){
        return this.TRACKING_COOKIE_NAME;
    }

}

export default StudyTwoProcedureConfig;